export enum RegistrationStatusType {
    NONE='None',
    CREATED='Created',
    ACTIVE='Active',
    REJECTED='Rejected'
}